import React from 'react';

interface LoggingIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const LoggingIcon: React.FC<LoggingIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill="#B5BCC4" fillRule="evenodd">
        <path d="M15.387 5.949c0 .407-.33.738-.738.738H8.08a.738.738 0 1 1 0-1.477h6.568c.408 0 .738.33.738.739ZM4.641 6.155a.738.738 0 1 1 1.418-.413.738.738 0 0 1-1.418.413ZM15.387 10c0 .408-.33.738-.738.738H8.08a.738.738 0 0 1 0-1.476h6.568c.408 0 .738.33.738.738ZM4.641 10.207a.738.738 0 1 1 1.418-.414.738.738 0 0 1-1.418.414ZM15.387 14.051c0 .408-.33.739-.738.739H8.08a.738.738 0 1 1 0-1.477h6.568c.408 0 .738.33.738.738ZM4.641 14.258a.738.738 0 1 1 1.418-.414.738.738 0 0 1-1.418.414Z" />
        <path d="M1.666 4.093a2.426 2.426 0 0 1 2.426-2.426h11.814a2.426 2.426 0 0 1 2.427 2.426v11.814a2.426 2.426 0 0 1-2.426 2.426H4.091a2.426 2.426 0 0 1-2.426-2.426V4.093Zm2.426-.95a.95.95 0 0 0-.95.95v11.814c0 .524.426.95.95.95h11.814a.95.95 0 0 0 .95-.95V4.093a.95.95 0 0 0-.95-.95H4.092Z" />
      </g>
    </svg>
  );
};
